import { gql } from '@apollo/client'

/**
 * Query to get the members of the workspace
 */
export const GET_WORKSPACE_MEMBERS = gql`
  query WorkspaceMembers($input: WorkspaceMembersDTO) {
    workspaceMembers(input: $input) {
      userID
      workspaceID
      accessType
      status
      user {
        id
        name
        photo
        email
        phone
        countryCode
      }
    }
  }
`

export const DOES_USER_EXIST = gql`
  query DoesUserExist($emailOrPhone: String!) {
    userExists(input: { emailOrPhone: $emailOrPhone }) {
      id
      countryCode
      phone
      email
      name
      photo
      memberships {
        workspaceID
        role
        workspace {
          displayName
          logo
        }
      }
    }
  }
`

export const GET_ENTERPRISE_CHILD_WORKSPACES = gql`
  query EnterpriseChildWorkspaces {
    enterpriseChildWorkspaces {
      id
      displayName
      enterpriseWorkspaceID
      isEnterpriseWorkspace
      logo
      workspacename
      workspaceType
    }
  }
`

export const GET_ENTERPRISE_WORKSPACE_MEMBERS = gql`
  query EnterpriseWorkspaceMembers($input: EnterpriseWorkspaceMembersDTO) {
    enterpriseWorkspaceMembers(input: $input) {
      accessType
      status
      userID
      workspaceID
      user {
        id
        name
        photo
        email
        phone
        countryCode
      }
      workspace {
        id
        displayName
        workspacename
      }
    }
  }
`

export const GET_ENTERPRISE_WORKSPACE_INVITATIONS = gql`
  query EnterpriseWorkspaceInvitations($input: EnterpriseWorkspaceInvitationsDTO) {
    enterpriseWorkspaceInvitations(input: $input) {
      accessType
      expirationDate
      userID
      workspaceID
      user {
        id
        name
        photo
        email
        phone
        countryCode
      }
      workspace {
        id
        displayName
        workspacename
      }
    }
  }
`
